"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gt = void 0;

var _curry = require("../curry/curry");

var _gt = function _gt(a, b) {
  return a < b;
};
/**
 * Grater compare.
 *
 * @param {Number} a First number
 * @param {Number} b Second number
 *
 * @return {Boolean}
 *
 * @tag Core
 * @signature (a: Number) => (b: Number): Boolean
 * @signature (a: Number, b: Number): Boolean
 *
 * @example
 * gt(10)(4)
 * // => false
 *
 * gt(10, 14)
 * // => true
 */


var gt = (0, _curry.curry)(_gt);
exports.gt = gt;